/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/overridden_schemas/OCRTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
/** @internal */
export var OcrElement;
(function (OcrElement) {
    /** @internal */
    function from(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'Glyph':
                return new Glyph(source);
            case 'Word':
                return new Word(source);
            case 'Line':
                return new Line(source);
            case 'Block':
                return new Block(source);
            case 'Page':
                return new OcrPage(source);
            default:
                throw new Error(`Unknown child class name: ${_type}`);
        }
    }
    OcrElement.from = from;
})(OcrElement || (OcrElement = {}));
/**
Represents a single glyph, i.e. a character.
*/
export class Glyph {
    /** @param source {@displayType `DeepPartial<Glyph>`} */
    constructor(source = {}) {
        this._type = 'Glyph';
        if (source.text !== undefined) {
            this.text = source.text;
        }
        else {
            throw new Error('text must be present in constructor argument');
        }
        if (source.confidence !== undefined) {
            this.confidence = source.confidence;
        }
        else {
            throw new Error('confidence must be present in constructor argument');
        }
        if (source.roi !== undefined) {
            this.roi = source.roi.map((it) => {
                return { x: it.x, y: it.y };
            });
        }
        else {
            throw new Error('roi must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
        };
    }
}
/**
Represents a single word. A word is made up of glyphs.
*/
export class Word {
    /** @param source {@displayType `DeepPartial<Word>`} */
    constructor(source = {}) {
        this._type = 'Word';
        if (source.text !== undefined) {
            this.text = source.text;
        }
        else {
            throw new Error('text must be present in constructor argument');
        }
        if (source.confidence !== undefined) {
            this.confidence = source.confidence;
        }
        else {
            throw new Error('confidence must be present in constructor argument');
        }
        if (source.roi !== undefined) {
            this.roi = source.roi.map((it) => {
                return { x: it.x, y: it.y };
            });
        }
        else {
            throw new Error('roi must be present in constructor argument');
        }
        if (source.glyphs !== undefined) {
            this.glyphs = source.glyphs.map((it) => {
                return new Glyph(it);
            });
        }
        else {
            throw new Error('glyphs must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            glyphs: this.glyphs.map((it) => {
                return it.serialize(config);
            }),
        };
    }
}
/**
Represents a single line. A line is made up of words.
*/
export class Line {
    /** @param source {@displayType `DeepPartial<Line>`} */
    constructor(source = {}) {
        this._type = 'Line';
        if (source.text !== undefined) {
            this.text = source.text;
        }
        else {
            throw new Error('text must be present in constructor argument');
        }
        if (source.confidence !== undefined) {
            this.confidence = source.confidence;
        }
        else {
            throw new Error('confidence must be present in constructor argument');
        }
        if (source.roi !== undefined) {
            this.roi = source.roi.map((it) => {
                return { x: it.x, y: it.y };
            });
        }
        else {
            throw new Error('roi must be present in constructor argument');
        }
        if (source.words !== undefined) {
            this.words = source.words.map((it) => {
                return new Word(it);
            });
        }
        else {
            throw new Error('words must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            words: this.words.map((it) => {
                return it.serialize(config);
            }),
        };
    }
}
/**
Represents a single block, e.g. a paragraph. A block is made up of lines.
*/
export class Block {
    /** @param source {@displayType `DeepPartial<Block>`} */
    constructor(source = {}) {
        this._type = 'Block';
        if (source.text !== undefined) {
            this.text = source.text;
        }
        else {
            throw new Error('text must be present in constructor argument');
        }
        if (source.confidence !== undefined) {
            this.confidence = source.confidence;
        }
        else {
            throw new Error('confidence must be present in constructor argument');
        }
        if (source.roi !== undefined) {
            this.roi = source.roi.map((it) => {
                return { x: it.x, y: it.y };
            });
        }
        else {
            throw new Error('roi must be present in constructor argument');
        }
        if (source.lines !== undefined) {
            this.lines = source.lines.map((it) => {
                return new Line(it);
            });
        }
        else {
            throw new Error('lines must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            lines: this.lines.map((it) => {
                return it.serialize(config);
            }),
        };
    }
}
/**
Represents result of performing OCR on an image. A page is made up of blocks.
*/
export class OcrPage {
    /** @param source {@displayType `DeepPartial<OcrPage>`} */
    constructor(source = {}) {
        this._type = 'Page';
        if (source.text !== undefined) {
            this.text = source.text;
        }
        else {
            throw new Error('text must be present in constructor argument');
        }
        if (source.confidence !== undefined) {
            this.confidence = source.confidence;
        }
        else {
            throw new Error('confidence must be present in constructor argument');
        }
        if (source.roi !== undefined) {
            this.roi = source.roi.map((it) => {
                return { x: it.x, y: it.y };
            });
        }
        else {
            throw new Error('roi must be present in constructor argument');
        }
        if (source.blocks !== undefined) {
            this.blocks = source.blocks.map((it) => {
                return new Block(it);
            });
        }
        else {
            throw new Error('blocks must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            _type: this._type,
            blocks: this.blocks.map((it) => {
                return it.serialize(config);
            }),
        };
    }
}
//# sourceMappingURL=OcrTypes.js.map